import { useMemo } from "react";

type PaginationItem = number | "...";

export const usePaginationRange = (
  currentPage: number,
  totalPages: number,
): PaginationItem[] => {
  return useMemo(() => {
    const MAX_VISIBLE = 7;
    const ELLIPSIS: PaginationItem = "...";

    if (totalPages <= MAX_VISIBLE) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }

    if (currentPage <= 4) {
      return [1, 2, 3, 4, 5, ELLIPSIS, totalPages];
    }

    if (currentPage >= totalPages - 3) {
      return [
        1,
        ELLIPSIS,
        totalPages - 4,
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
        totalPages,
      ];
    }

    return [
      1,
      ELLIPSIS,
      currentPage - 1,
      currentPage,
      currentPage + 1,
      ELLIPSIS,
      totalPages,
    ];
  }, [currentPage, totalPages]);
};
